<template>
  <div class="page">
    <!-- 搜索 -->
    <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small"
      class="query-form" @submit.native.prevent>
      <el-form-item label="线路名称">
        <el-input style="width: 177px;" v-model="queryForm.lineName"></el-input>
      </el-form-item>
      <el-form-item label="配送人姓名">
        <el-input style="width: 177px;" v-model="queryForm.personName"></el-input>
      </el-form-item>
      <el-form-item label="配送人电话">
        <el-input style="width: 177px;" v-model="queryForm.personMobile"></el-input>
      </el-form-item>
      <el-form-item label="用户">
        <GridSelectU style="width: 177px;" labelName="userName" title="选择用户"
          labelValue="id" :value="queryForm.userId" :limit='1' size='small' placeholder='请选择用户'
          @getValue="getSeachValueUser" :columns="USER_code" :searchs="USER_search" dataListUrl="/mpp/user/findList" entityBeanName="mppUser" queryEntityUrl="/mpp/user/get">
        </GridSelectU>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="getShopDeliverList">查询</el-button>
        <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
      </el-form-item>
    </el-form>
    <div class="page-content">
      <div class="page-tool-bar">
        <div class="el-btn-group">
          <el-button type="primary" size="small" icon="el-icon-plus" @click="addShopDeliver">新建</el-button>
          <el-button type="warning" plain size="small" icon="el-icon-edit" :disabled="multipleSelection.length != 1"
            @click="editShopDeliver(null)">修改</el-button>
          <el-button type="danger" plain size="small" icon="el-icon-delete" :disabled="multipleSelection.length <= 0"
            @click="deleteShopDeliver(null)">删除</el-button>
        </div>

        <div class="icon-group">
          <el-upload v-if="this.isImportDate" class="upload-demo" action="#" :http-request="upload"
            :show-file-list="true">
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
          </el-upload>
          <span title="搜索" class="icon-box" @click="search">
            <Icon color="#606266">
              <Search />
            </Icon>
          </span>
          <span title="下载模板" class="icon-box" @click="importTemplate">
            <Icon color="#606266">
              <ArrowDown />
            </Icon>
          </span>
          <span class="icon-box" title="导入数据" @click="isImport">
            <Icon color="#606266">
              <ArrowExportUp24Regular />
            </Icon>
          </span>
          <span title="导出数据" class="icon-box" @click="exportShopDeliverList">
            <Icon color="#606266">
              <ArrowDownload24Regular />
            </Icon>
          </span>
          <span class="icon-box" @click="refreshShopDeliverList">
            <Icon color="#606266">
              <Refresh />
            </Icon>
          </span>
        </div>
      </div>
      <!-- 列表数据 -->
      <el-table :data="shopDeliverList" row-key="id" border height="100%" :header-row-style="{ height: '10px' }"
        :header-cell-style="{ padding: '10px' }" :row-style="{ height: '9px' }" :cell-style="{ padding: '9px' }"
        @selection-change="handleSelectionChange" size="small">
        <el-table-column align="center" type="selection" width="60"> </el-table-column>
        <el-table-column :show-overflow-tooltip="true" align="center" prop="lineName" label="线路名称" width="180">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" align="center" prop="personName" label="配送人姓名" width="180">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" align="center" prop="personHeader" label="配送人头像" width="180">
          <template slot-scope="scope">
            <div v-if='scope.row.personHeader'>
              <el-image @click='updateSrcList(scope.row.personHeader)' style="width: 60px; height: 60px"
                :src="scope.row.personHeader" :preview-src-list="srcList"> </el-image>
            </div>
            <div v-else>--</div>
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" align="center" prop="personMobile" label="配送人电话" width="180">
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" align="center" prop="userId" label="用户" width="180">
          <template slot-scope="scope">
            <div v-if="scope.row.user">
                <div style="text-align: left">账号：{{ scope.row.user.userName }}</div>
                <div style="text-align: left">手机：{{ scope.row.user.userMobile }}</div>
                <div style="text-align: left">昵称：{{ scope.row.user.userNickname }}</div>
                <div style="text-align: left">姓名：{{ scope.row.user.userRealname }}</div>
            </div>
            <div v-else>--</div>
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" align="center" prop="remarks" label="备注" width="180">
        </el-table-column>
        <el-table-column fixed="right" align="center" label="操作" width="300">
          <template slot-scope="scop">
            <div class="operation">
              <div @click="allotUser(scop.row.id)">
                <Icon size="16">
                  <Edit24Regular />
                </Icon>
                <span class="operation-label">配送门店</span>
              </div> 
              <div @click="checkShopDeliver(scop.row.id)">
                <Icon size="16">
                  <Eye24Regular />
                </Icon>
                <span class="operation-label">查看</span>
              </div>
              <div @click="editShopDeliver(scop.row.id)">
                <Icon size="16">
                  <Edit24Regular />
                </Icon>
                <span class="operation-label">修改</span>
              </div>
              <div @click="deleteShopDeliver(scop.row.id)">
                <Icon size="16" style="color: red">
                  <Delete24Regular />
                </Icon>
                <span class="operation-label" style="color: red">删除</span>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-box">
        <el-pagination @size-change="sizeChange" @current-change="currentChange" :current-page.sync="currentPage"
          :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="totalNum" background :pager-count="7">
        </el-pagination>
      </div>
      <!-- 新增/查看/修改信息 -->
      <el-dialog :title="shopDeliverStates[shopDeliverState]" :visible.sync="showDialog" width="60%" @close="closeDialog">
        <div>
          <el-form :model="shopDeliver" ref="shopDeliverForm" :rules="rules" label-width="120px" :inline="true"
            size="small">
            <el-form-item label="线路名称" prop="lineName">
              <el-input style="width: 177px;" size="small" v-model="shopDeliver.lineName" :disabled="shopDeliverState == 'check'"></el-input>
            </el-form-item>
            <el-form-item label="配送人姓名" prop="personName">
              <el-input style="width: 177px;" size="small" v-model="shopDeliver.personName" :disabled="shopDeliverState == 'check'"></el-input>
            </el-form-item>
            <el-form-item label="配送人电话" prop="personMobile">
              <el-input style="width: 177px;" size="small" v-model="shopDeliver.personMobile"
                :disabled="shopDeliverState == 'check'"></el-input>
            </el-form-item>
            <el-form-item label="用户" prop="userId">
              <GridSelectU style="width: 177px;" title="选择用户" labelName="userName" :disabled="shopDeliverState == 'check'"
                labelValue="id" :value="shopDeliver.userId" :limit='1' size='small' placeholder='请选择用户'
                @getValue="getValueUser" :columns="USER_code" :searchs="USER_search" dataListUrl="/mpp/user/findList" entityBeanName="mppUser" queryEntityUrl="/mpp/user/get">
              </GridSelectU>
            </el-form-item>
            <el-form-item label="备注" prop="remarks">
              <el-input style="width: 177px;" size="small" v-model="shopDeliver.remarks" :disabled="shopDeliverState == 'check'"></el-input>
            </el-form-item>
            <el-form-item label="配送人头像" prop="personHeader">
              <el-upload :action="action" :headers="header" :before-upload="beforeImageUpload"
                :disabled="shopDeliverState == 'check'" class="avatar-uploader" :show-file-list="false"
                :http-request="uploadImage">
                <img v-if="shopDeliver.personHeader" :src="shopDeliver.personHeader" class="avatar" size="small" />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
          </el-form>
        </div>

        <div slot="footer" class="flex justify-end">
          <el-button @click="closeDialog">关闭</el-button>
          <el-button type="primary" @click="submitForm" v-if="shopDeliverState != 'check'">确定</el-button>
        </div>
      </el-dialog>
    </div>
    <AllotStore ref="allotStore" :id="currentRole"></AllotStore>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun, upload } from '@/utils/request.js';
import GridSelectU from '@/components/gridselect';
import { UPLOAD_PATH, UPLOAD_API, USER, USER_SEARCH } from '@/utils/constant.js';
import AllotStore from '@/components/StoreManagement/AllotStore.vue';

export default {
  components: {
    Edit24Regular,
    Delete24Regular,
    Eye24Regular,
    GridDots,
    Refresh,
    Printer,
    ArrowUp,
    ArrowDown,
    ArrowDownload24Regular,
    ArrowExportUp24Regular,
    Search,
    GridSelectU,
    AllotStore
  },
  watch: {
    checkState(val) {
      if (val == 'check') {
        this.resetShopDeliverList();
        this.getShopDeliverList(this.queryForm);
        this.$emit('resetCheckState');
      } else if (val == 'reset') {
        this.resetShopDeliverList();
        this.getShopDeliverList();
        this.$emit('resetCheckState');
      }
    }
  },
  data() {
    return {
      USER_code: USER,
      USER_search: USER_SEARCH,
      queryForm: {
        id: '', //ID
        lineName: '', //线路名称
        personName: '', //配送人姓名
        personHeader: '', //配送人头像
        personMobile: '', //配送人电话
        userId: '', //用户
        remarks: '', //备注
      },
      srcList:[''],
      header: {
        token: localStorage.getItem('token')
      },
      action: UPLOAD_API + UPLOAD_PATH,
      loading: false,
      showDialog: false,
      isImportDate: false,
      isSearch: false,
      pageSize: 10,
      currentPage: 1,
      totalNum: 0,
      currentUserId: '',
      shopDeliverState: 'add',
      shopDeliverStates: {
        add: '新建配送信息',
        check: '查看配送信息',
        edit: '修改配送信息'
      },

      multipleSelection: [],
      shopDeliverList: [],
      shopDeliver: {
        id: '', //ID
        lineName: '', //线路名称
        personName: '', //配送人姓名
        personHeader: '', //配送人头像
        personMobile: '', //配送人电话
        userId: '', //用户
        remarks: '', //备注
      },
      btnLoading: false,
      currentRole : '',
      rules: {
        id: [{ required: true, message: 'ID不能为空', trigger: 'blur' }],
        lineName: [{ required: true, message: '线路名称不能为空', trigger: 'blur' }],
        personName: [{ required: true, message: '配送人姓名不能为空', trigger: 'blur' }],
        personHeader: [{ required: true, message: '配送人头像不能为空', trigger: 'blur' }],
        personMobile: [{ required: true, message: '配送人电话不能为空', trigger: 'blur' }],
        userId: [{ required: true, message: '用户不能为空', trigger: 'blur' }],
        // remarks: [{ required: true, message: '备注不能为空', trigger: 'blur' }],
      }
    };
  },
  created() {
    this.getShopDeliverList();
  },
  methods: {
    beforeImageUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 50;
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 50MB!');
      }
      return isLt2M;
    },
    allotUser(role) {
      //console.log(role);
      this.currentRole = role;
      setTimeout(() => {
          this.$refs.allotStore.init();
      }, 200);
    },
    //上传缩略图
    uploadImage(params) {
      console.log(params);
      const file = params.file;
      let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
      if (!types.includes(file.type)) {
        this.$message.error('图片类型错误!');
      }
      const formData = new FormData();
      formData.append('file', file);
      upload(UPLOAD_PATH, formData).then((res) => {
        if (res.success) {
          this.shopDeliver.personHeader = res.url;
        }
      });
    },
    getValueUser(value) {
      this.shopDeliver.userId = value
    },
    getSeachValueUser(value){
      this.queryForm.userId = value
    },
    search() {
      this.isSearch = !this.isSearch;
    },
    resetShopDeliverList() {
      this.pageSize = 10;
      this.currentPage = 1;
      this.shopDeliverList = [];
    },
    resetDialog() {
      this.shopDeliverState = 'add';
      this.showDialog = false;
      this.queryForm = {
        id: '', //ID
        lineName: '', //线路名称
        personName: '', //配送人姓名
        personHeader: '', //配送人头像
        personMobile: '', //配送人电话
        userId: '', //用户
        remarks: '', //备注
      };
      this.getShopDeliverList();
    },
    closeDialog() {
      this.showDialog = false
      this.shopDeliver = {
        id: '', //ID
        lineName: '', //线路名称
        personName: '', //配送人姓名
        personHeader: '', //配送人头像
        personMobile: '', //配送人电话
        userId: '', //用户
        remarks: '', //备注
      };
    },
    // 大图预览
    updateSrcList(src) {
      this.srcList[0] = src
    },
    submitForm() {
      if (this.shopDeliverState == 'add') {
        this.$refs.shopDeliverForm.validate((valid) => {
          if (valid) {
            console.log('submit');
            post(`/shop/deliver/add`, { ...this.shopDeliver }).then((res) => {
              if (res.success) {
                this.$message({
                  message: res.msg,
                  type: 'success',
                  duration: 2000,
                });
                this.resetShopDeliverList();
                this.resetDialog();
              } else {
                this.$message({
                  message: res.msg,
                  type: 'error',
                  duration: 2000
                });
              }
            });
          }
        });
      } else if (this.shopDeliverState == 'edit') {
        this.$refs.shopDeliverForm.validate((valid) => {
          if (valid) {
            console.log('submit');
            delete this.shopDeliver.user
            post(`/shop/deliver/edit`, { ...this.shopDeliver }).then((res) => {
              if (res.success) {
                this.$message({
                  message: res.msg,
                  type: 'success',
                  duration: 2000
                });
                this.resetShopDeliverList();
                this.resetDialog();
              } else {
                this.$message({
                  message: res.msg,
                  type: 'error',
                  duration: 2000
                });
              }
            });
          }
        });
      }
    },
    addShopDeliver() {
      this.showDialog = true;
      this.shopDeliverState = 'add';
    },
    checkShopDeliver(shopDeliverId) {
      console.log(shopDeliverId);
      this.currentShopDeliverId = shopDeliverId;

      this.getShopDeliverById();
      this.showDialog = true;
      this.shopDeliverState = 'check';
    },
    editShopDeliver(shopDeliverId) {
      console.log('shopDeliver', shopDeliverId);
      if (shopDeliverId) {
        this.currentShopDeliverId = shopDeliverId;
        this.getShopDeliverById();
      } else {
        this.shopDeliver = { ...this.shopDeliver, ...this.multipleSelection[0] };
      }

      this.showDialog = true;
      this.shopDeliverState = 'edit';
    },
    deleteShopDeliver(shopDeliverId) {
      let ids = '';
      if (shopDeliverId) {
        ids = shopDeliverId;
      } else {
        ids = this.multipleSelection.map((shopDeliver) => shopDeliver.id).join(',');
      }
      console.log({ ids });
      this.$confirm('确定删除所选项吗？', '提示', {
        type: 'warning'
      })
        .then(() => {
          deleteFun(`/shop/deliver/delete`, { ids }).then((res) => {
            if (res.success) {
              this.$message({
                message: res.msg,
                type: 'success',
                duration: 2000
              });
              this.resetShopDeliverList();
              this.getShopDeliverList();
            } else {
              this.$message({
                message: res.msg,
                type: 'error',
                duration: 2000
              });
            }
          });
        })
        .catch(() => { });
    },
    refreshShopDeliverList() {
      this.resetShopDeliverList();
      this.getShopDeliverList();
    },
    getShopDeliverList(query = {}) {
      this.loading = true;
      get(`/shop/deliver/findList`, { ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
        this.loading = false;
        if (res.success) {
          this.shopDeliverList = res.page.list;
          console.log(this.shopDeliverList);
          this.totalNum = res.page.total;
        } else {
          this.$message({
            message: res.msg,
            type: 'error',
            duration: 2000
          });
        }
      });
    },
    getShopDeliverById() {
      get(`/shop/deliver/get`, { id: this.currentShopDeliverId }).then((res) => {
        if (res.success) {
          this.shopDeliver = { ...this.shopDeliver, ...res.shopDeliver };
        } else {
          this.$message({
            message: res.msg,
            type: 'error',
            duration: 2000
          });
        }
      });
    },
    /**
     * 导出信息
     */
    exportShopDeliverList() {
      //this.btnLoading = true;
      exprotExcel(`/shop/deliver/export`, { ...this.queryForm });
    },
    /**
     * 导出模板
     */
    importTemplate() {
      this.btnLoading = true;
      importTemplate(`/shop/deliver/importTemplate`, this.btnLoading);
    },
    /**
     * 导入数据
     */
    isImport() {
      this.isImportDate = !this.isImportDate;
    },
    upload(params) {
      const file = params.file;
      const formData = new FormData();
      formData.append('file', file);
      console.log({ formData });
      importDate(`/shop/deliver/importData`, formData);
      this.refreshShopDeliverList();
    },
    handleSelectionChange(value) {
      console.log(value);
      this.multipleSelection = value;
    },
    currentChange(page) {
      this.currentPage = page;
      this.getShopDeliverList();
    },
    sizeChange(size) {
      this.pageSize = size;
      this.getShopDeliverList();
    }
  }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  button{
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.avatar {
  width: 180px;
  height: 180px;
  display: block;
}

::v-deep .el-upload--text {
  width: 180px;
  height: 180px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 150px;
  height: 150px;
  line-height: 180px;
  text-align: center;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.operation {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #409eff;
  font-size: 12px;

  &>div {
    display: flex;
    align-items: center;
    padding: 0 5px;
    cursor: pointer;
  }

  .operation-label {
    margin-left: 3px;
  }
}
</style>